import { render, staticRenderFns } from "./PlatformQqNeteaseDetail.vue?vue&type=template&id=50f2b38a&scoped=true"
import script from "./PlatformQqNeteaseDetail.vue?vue&type=script&lang=js"
export * from "./PlatformQqNeteaseDetail.vue?vue&type=script&lang=js"
import style0 from "./PlatformQqNeteaseDetail.vue?vue&type=style&index=0&id=50f2b38a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f2b38a",
  null
  
)

export default component.exports